// Events & Sponsorship sales — shared labels (BK + Gene, 10/8/26). Backend: AzureApp src/functions/eventsSponsorship.js.

// Gene's stages, plus Follow Up Scheduled (derived from the latest logged contact, same rule as every board).
export const STAGE_META = {
  new_lead:      { label: 'New Lead',      color: '#9ca3af', desc: 'Not contacted yet.' },
  contacted:     { label: 'Contacted',     color: '#60a5fa', desc: 'Reached out at least once; no real conversation yet.' },
  follow_up:     { label: 'Follow Up Scheduled', color: '#3b82f6', desc: 'A follow-up is on the calendar. Stays here until the next contact is logged; red once overdue.' },
  qualified:     { label: 'Qualified',     color: '#a78bfa', desc: 'Real interest, budget and a decision maker identified.' },
  proposal_sent: { label: 'Proposal Sent', color: '#eab308', desc: 'Proposal is out, waiting on an answer.' },
  negotiation:   { label: 'Negotiation',   color: '#f97316', desc: 'Working through terms or price.' },
  closed_won:    { label: 'Closed Won',    color: '#22c55e', desc: 'Signed.' },
  closed_lost:   { label: 'Closed Lost',   color: '#ef4444', desc: 'Not moving forward (reason required).' },
};
export const COLUMN_ORDER = ['new_lead', 'contacted', 'follow_up', 'qualified', 'proposal_sent', 'negotiation', 'closed_won', 'closed_lost'];
// The real stored stages (what the stage picker offers).
export const STAGES = ['new_lead', 'contacted', 'qualified', 'proposal_sent', 'negotiation', 'closed_won', 'closed_lost'];
export const OPEN_STAGES = STAGES.slice(0, 5);

export const PRIORITY_META = {
  high:   { label: 'High',   color: '#ef4444' },
  medium: { label: 'Medium', color: '#f59e0b' },
  low:    { label: 'Low',    color: '#9ca3af' },
};

export const CATEGORIES = {
  physical_therapy: 'Physical Therapy', fitness_gym: 'Fitness / Gym', med_spa: 'Med Spa', chiropractic: 'Chiropractic',
  credit_union_bank: 'Credit Union / Bank', auto_dealership: 'Auto Dealership', restaurant_food: 'Restaurant / Food',
  real_estate: 'Real Estate', insurance: 'Insurance', healthcare: 'Healthcare', corporate_office: 'Corporate Office',
  retail: 'Retail', other: 'Other',
};

export const CLASSIFICATIONS = { new: 'New', renewal: 'Renewal', expansion: 'Expansion', winback: 'Win Back' };

export const METHODS = {
  call: 'Call', email: 'Email', text: 'Text', meeting: 'Meeting', in_person: 'In person', linkedin: 'LinkedIn', note: 'Note only',
};
export const OUTCOMES = {
  connected: 'Talked with them', meeting_held: 'Meeting held', no_answer: 'No answer', left_voicemail: 'Left voicemail',
  email_sent: 'Email sent', text_sent: 'Text sent', proposal_sent: 'Proposal sent',
};

export const CLUB_OPTIONS = [
  { id: 'DEN', name: 'Denton' }, { id: 'LEW', name: 'Lewisville' }, { id: 'MCK', name: 'McKinney' },
  { id: 'GB', name: 'Green Bay' }, { id: 'MF', name: 'Menomonee Falls' }, { id: 'WA', name: 'West Allis' },
];

export function money(v) {
  if (v === null || v === undefined || v === '') return '';
  return `$${Number(v).toLocaleString(undefined, { maximumFractionDigits: 0 })}`;
}

export function shortDate(iso) {
  if (!iso) return '';
  const d = iso.length === 10 ? new Date(iso + 'T12:00:00') : new Date(iso);
  return d.toLocaleDateString(undefined, { month: 'numeric', day: 'numeric' });
}

export function todayISO() {
  return new Date().toLocaleDateString('en-CA', { timeZone: 'America/Chicago' });
}

export function Pill({ color, children, title }) {
  return (
    <span title={title} style={{
      background: `${color}22`, color, border: `1px solid ${color}`, fontSize: 9, fontWeight: 700,
      padding: '2px 6px', borderRadius: 4, textTransform: 'uppercase', letterSpacing: 0.4,
      marginRight: 4, display: 'inline-block', marginBottom: 3, whiteSpace: 'nowrap',
    }}>{children}</span>
  );
}

export function FollowUpPill({ date, overdue, missing }) {
  if (missing) return <Pill color="#ef4444" title="On an open deal with no next step">No follow-up set</Pill>;
  if (!date) return null;
  const t = todayISO();
  const color = overdue ? '#ef4444' : date === t ? '#f59e0b' : '#3b82f6';
  return <Pill color={color}>📅 {overdue ? 'Overdue ' : ''}{shortDate(date)}</Pill>;
}
